module.exports = __webpack_public_path__ + "a8bb1090bf7c7b2e85f429d9bedb3d38.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/ME.svg
// module id = hHxR
// module chunks = 0